module.exports = __webpack_public_path__ + "static/media/ERTHA.26d39821.png";